export const FLEET_CAMPAIGNS_TITLE = {
  pt: "GESTÃO DE CAMPANHAS PARA FROTAS",
  es: "GESTIÓN DE CAMPAÑAS PARA FLOTAS",
  en: "FLEET CAMPAIGN MANAGEMENT",
};

export const FLEET_CAMPAIGNS_DESCRIPTION_1 = {
  pt: "Crie e configure rapidamente uma campanha de carregamento para seus clientes de Frotas.",
  es: "Cree y configure rápidamente una campaña de carga para sus clientes de flotas.",
  en: "Quickly create and configure a charging campaign for your fleet customers.",
};

export const FLEET_CAMPAIGNS_DESCRIPTION_2 = {
  pt: "Defina o valor do kWh negociado, carregue a lista de usuários e estabeleça as regras de uso para liberar o benefício.",
  es: "Defina el valor del kWh negociado, cargue la lista de usuarios y establezca las reglas de uso para liberar el beneficio.",
  en: "Set the negotiated kWh price, upload the user list and define usage rules to grant the benefit.",
};

export const FLEET_ALERT_ATTENTION = {
  pt: "Atenção:",
  es: "Atención:",
  en: "Attention:",
};

export const FLEET_ALERT_ITEM_1 = {
  pt: "• Não haverá cobrança para o motorista/usuário final. A forma de cobrança deve ser definida previamente com seu cliente Frota.",
  es: "• No habrá cobro para el conductor/usuario final. La forma de cobro debe definirse previamente con su cliente de flota.",
  en: "• There will be no charge for the driver/end user. The charging model must be agreed in advance with your fleet customer.",
};

export const FLEET_ALERT_ITEM_2 = {
  pt: "• A taxa Tupi será aplicada sobre o valor total da carga no valor do kWh negociado, conforme seu contrato e as configurações nesta ferramenta.",
  es: "• La tarifa Tupi se aplicará sobre el valor total de la carga al valor del kWh negociado, según su contrato y las configuraciones de esta herramienta.",
  en: "• The Tupi fee will be applied to the total charging amount at the negotiated kWh price, according to your contract and this tool's settings.",
};

export const FLEET_ALERT_ITEM_3 = {
  pt: "• Taxa de ociosidade poderá ser aplicada à carga conforme regras das estações utilizadas.",
  es: "• Se podrá aplicar una tarifa de ociosidad a la sesión de carga según las reglas de las estaciones utilizadas.",
  en: "• An idle fee may be applied to the charging session according to the rules of the stations used.",
};
